import { makeStyles } from "@fluentui/react-components";

export const useEditTagStyles = makeStyles({
  dialogSurface: {
    maxWidth: "650px",
    minHeight: "600px",
    maxHeight: "85vh",
  },

  dialogBody: {
    minHeight: "480px",
  },

  attachmentsList: {
    maxHeight: "200px",
    overflowY: "auto" as const,
  },

  dropdownListbox: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    maxHeight: "200px !important" as any,
  },
});
